<div class="coverpath-base-widget payment-if-missing">
  <div class="header">
    <div class="header__content header__content-close">
      <button type="button" class="close" (click)="cancel()">Close</button>
    </div>
  </div>
  <div class="wrap wrapMain payment-if-missing--main">
    <div class="wrap wrapHead payment-if-missing--head">
      <div class="pageHead">
        <h1 class="removeTopMargin">Accept Offer</h1>
      </div>
      <div class="subhead">
        To accept this offer, provide your bank information below. Your coverage begins as soon as we receive payment
        and your final signature.
      </div>
      <div class="center">
        <img src="/common/widgets/icons/divider.svg" />
      </div>
    </div>
    <div class="section-container">
      <div class="half-section payment-if-missing--information">
        <div>
          <div class="payment-if-missing-subsection">
            <div class="payment-if-missing--subsection-headline">
              {{ coverageLabel }}
            </div>
            <div class="payment-if-missing--premium-item">
              <div class="payment-if-missing--currency">{{ totalCoverage }}</div>
              <div class="payment-if-missing--explanation">
                {{ productDescription }}
              </div>
            </div>
          </div>
          <div class="payment-if-missing-subsection">
            <div class="payment-if-missing--subsection-headline">AMOUNT DUE</div>
            <div class="quote-page-product__field">
              <div id="prepare-quote-form__premium" class="quote-page-product__premium">
                <div class="payment-if-missing--currency">
                  {{ amountDue }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="half-section payment-if-missing--form">
        <div class="payment-if-missing--form-headline">Payment Method</div>
        <div class="quote-page-product__fields payment-if-missing--fields">
          <div class="quote-page-product__field-group">
            <div class="quote-page-product__field quote-page-product__field--face-amount">
              <basic-text-input
                propertyName="accountCenterController.paymentInformation.paymentBankName"
                placeholder="Bank Name"
                label="Bank Account"
                (change)="updateValidation()"
                #bankName
              ></basic-text-input>
              <select-basic
                propertyName="accountCenterController.paymentInformation.paymentAccountType"
                [label]="'Account Type'"
                (valueChanged)="updateValidation()"
                #accountType
              ></select-basic>
              <basic-text-input
                propertyName="accountCenterController.paymentInformation.paymentABA"
                placeholder="Routing Number"
                label="Routing Number"
                (change)="updateValidation()"
                #ABA
              ></basic-text-input>
              <basic-text-input
                propertyName="accountCenterController.paymentInformation.paymentAccount"
                placeholder="Account Number"
                label="Account Number"
                (change)="updateValidation()"
                #Account
              ></basic-text-input>
            </div>
          </div>
        </div>
      </div>
      <div class="payment-if-missing--alert-container" *ngIf="isInvalidPaymentInfo()">
        <cpds-alert intent="danger" class="payment-if-missing--alert-container">
          <span>{{ paymentInfoError }} </span>
        </cpds-alert>
      </div>
      <div class="payment-if-missing--button-outer-container">
        <div class="payment-if-missing--button-container">
          <button
            class="button button--blue button--primary modal__button"
            [disabled]="submitDisabled"
            (click)="onSubmit()"
          >
            SUBMIT
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
